export default {
  
  methods: {
    
    draw_Radial() {

      this.radialCanvas = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.pie.x}, ${this.pie.y})`)
      .attr('font-family', 'roboto')
      .style('cursor', 'default')

      let pieTitle = this.radialCanvas
      .append('g')
      .attr('id', `CENTER_TITLE`)
      .attr('transform', `translate(0,0)`).attr('opacity', 1)

      pieTitle
      .append('text')
      .attr('x', 0).attr('y', 0)
      .attr('font-size', 15).attr('fill', '#000')
      .attr('text-anchor', 'middle')
      .text('Mechanical Completion')

      this.pie_Summary(pieTitle, 'MCC', this.mcc, -50, -35)
      this.pie_Summary(pieTitle, 'A-ITR', this.itrA, -50, 20)

      this.pie_Detail()
      this.donut_Controller()
    },


    donut_Controller() {
      let pie = this.pie
      let space = 30
      let fa = space/2
      let sRa = this.pie.inRa
      let gap = 1
      let len = null

      let sumTotal = this.rawData.map(d => d[`${this.ITR}_TOT`]).reduce((a, b) => (a + b))

      // Grids
      this.draw_Grids(sRa) // -----> draw_RadialChart.js

      this.rawData.forEach((d, i) => {

        let angle = (360-space) * (d[`${this.ITR}_TOT`]/sumTotal)
        if(i == 0 || i == 1) angle += 1
        if(i == 2 || i == 3) angle += 1.5
        if(i == 43) angle += 5

        // Total
        len = pie.ra
        this.draw_Pie(angle, fa, len, sRa, {
          gap:      gap,
          space:    space,
          bColor:   '#E0E0DF', 
          sColor:   '#bcbcbc', 
          sWidth:   .5,
          opacity:  [.1, .5],
          id:       'TOTAL',
          data:     d,
        }) // -----> draw_RadialChart.js

        // Actual
        len = (pie.ra * sRa) + ((pie.ra * (1 - sRa)) * (d[`${this.ITR}_PRO`]/100))
        this.draw_Pie(angle, fa, len, sRa, {
          gap:      gap,
          space:    space,
          bColor:   this.color21[i], 
          sColor:   this.color21[i], 
          sWidth:   1,
          opacity:  [1, 1],
          id:       'ACTUAL',
          data:     d,
        }) // -----> draw_RadialChart.js
        
        fa = fa + angle
      })
    },
  
  }
}